import { useViewSettingsStore } from "..";
import detailsStyles from "../components/Details.module.css";
import { DetailsPanelState } from "../store/ViewSettingsStore";

export default function useBodyContainerClassName(): string {
    const viewSettingsStore = useViewSettingsStore();

    return viewSettingsStore.detailsPanelState === DetailsPanelState.Left && !viewSettingsStore.isDetailsFullScreen
        ? detailsStyles.bodyContainerSlim
        : detailsStyles.bodyContainer;
}